<template>
  <div class="five columns"> 
    <div class="lotNumberContainer"> 
      <div class="lotNumber">
        Lot {{ inventoryItem.lot_number }}
      </div>
    </div>
    <h5>{{ inventoryItem.lead }}</h5>
    <div style="width:90%; float:left; padding-left:50px; padding-bottom:0px; font-size:12px;">
      <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;#{{ inventoryItem.customer_bidcard_number }}&nbsp;-&nbsp;{{ inventoryItem.customer_first_name }} {{ inventoryItem.customer_last_name }}
    </div>
    <div style="width:430px; float:left; padding-left:50px; padding-bottom:5px; font-size:12px; ">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PHONE1:&nbsp;{{ inventoryItem.primary_phone }}<br>
    </div>
    <div
      v-if="inventoryItem.secondary_phone"
      style="width:430px; float:left; padding-left:50px; padding-bottom:5px; font-size:12px; "
    >
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PHONE2:&nbsp;{{ inventoryItem.secondary_phone }}<br>
    </div>
    <div
      v-if="inventoryItem.backup_bid"
      style="width:210px; float:left; padding-left:10px; padding-bottom:5px; font-size:12px;"
    >
      Backup Bid:&nbsp;{{ inventoryItem.backup_bid }}<br>
    </div>
    <PhoneBiddingArea
      :item_id="inventoryItem.inventory_id"
      :assume_customer="inventoryItem.customer_unique_id"
    />
  </div>
</template>

<script>

import PhoneBiddingArea from '@/components/PhoneBiddingArea'

export default {
	name: 'PhoneAction',
	components: {
		PhoneBiddingArea
	},
	data () {
		return {
		}
	},
	computed: {
		inventoryItem: function () {
			let upcoming = null
			for(let i=0; i<this.$store.getters.phoneList.length; i++) {
				if(
					this.$store.getters.biddingStatuses['ITEMID_'+this.$store.getters.phoneList[i].inventory_id].has_passed == false &&
					this.$store.getters.biddingStatuses['ITEMID_'+this.$store.getters.phoneList[i].inventory_id].has_sold == false
				) {
					upcoming = this.$store.getters.phoneList[i]
					break
				}
			}
			return upcoming	
		}
	},
	mounted () {},
	methods: {
	}
}

</script>

<style scoped>

</style>
